const { setViewData, negotiateCssClass } = require('gui');

module.exports = function packagePresenter(pack) {
    const view = require('./packagePresenter.tpl.html');
    const c = {};

    c.activate = function(region) {
        view.activate(region);
        negotiateCssClass(view.wrapper, 'missing-package', pack.missing);
        setViewData(view, pack);
    };

    c.deactivate = function() {
        view.deactivate();
    };
    return c;
};
